import { gql } from 'graphql-request'

export const SINCRONIZAR_GRUPOS = gql`
  mutation SincronizarGruposMutation {
    sincronizarGrupos
  }
`
